import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  serviceOrderStats: null,
  isServiceStatsLoading: true,
};

const dashboardServiceSlice = createSlice({
  name: 'ServiceDashboard',
  initialState,
  reducers: {
    setServiceOrderStats(state, actions) {
      state.serviceOrderStats = actions.payload;
      state.isServiceStatsLoading = false;
    },
    setIsServiceStatsLoading(state, actions) {
      state.isServiceStatsLoading = actions.payload;
    },
  },
});
export const { setServiceOrderStats, setIsServiceStatsLoading } =
  dashboardServiceSlice.actions;
const dashboardServiceReducer = dashboardServiceSlice.reducer;
export default dashboardServiceReducer;
